export default "__VITE_ASSET__Cimxus$T__"